class generalHelper {
    constructor() {
        this.engageFakeHero();
    }

    engageFakeHero() {
        if (!document.querySelector('.hero')) {
            document.querySelector('.fake-hero').classList.add('shown');
        }
    }
}

new generalHelper();
